import { QRCodeSVG } from "qrcode.react";

const AppleLogo = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current shrink-0" aria-hidden="true">
    <path d="M17.05 20.28c-.98.95-2.05.86-3.08.35-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

const PlayLogo = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0" aria-hidden="true">
    <path fill="#4285F4" d="M3.6 22.1l10.4-10.1L3.6 1.9C3.2 2.2 3 2.7 3 3.3v17.4c0 .6.2 1.1.6 1.4z" />
    <path fill="#34A853" d="M14 12l3.5-3.4-12-6.9c-.4-.2-.9-.2-1.3 0L14 12z" />
    <path fill="#FBBC04" d="M14 12l-9.8 10.3c.4.2.9.2 1.3 0l12-6.9L14 12z" />
    <path fill="#EA4335" d="M17.5 8.6L14 12l3.5 3.4 4.2-2.4c1-.6 1-2 0-2.6l-4.2-2.4z" />
  </svg>
);

const storeButtonClass =
  "inline-flex items-center gap-3 rounded-xl bg-ink text-paper px-5 py-2.5 transition-all hover:bg-inksoft hover:-translate-y-0.5";

export const StoreButtons = ({ appStoreUrl = "", playStoreUrl = "" }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid="store-buttons">
    {appStoreUrl ? (
      <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className={storeButtonClass} data-testid="app-store-button">
        <AppleLogo />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wide opacity-70">Télécharger sur</span>
          <span className="block text-base font-bold">App Store</span>
        </span>
      </a>
    ) : (
      <span className={`${storeButtonClass} cursor-default`} title="Lien à venir" data-testid="app-store-button-soon">
        <AppleLogo />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wide opacity-70">App Store</span>
          <span className="block text-sm font-bold">Bientôt disponible</span>
        </span>
      </span>
    )}
    {playStoreUrl ? (
      <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className={storeButtonClass} data-testid="play-store-button">
        <PlayLogo />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wide opacity-70">Disponible sur</span>
          <span className="block text-base font-bold">Google Play</span>
        </span>
      </a>
    ) : (
      <span className={`${storeButtonClass} cursor-default`} title="Lien à venir" data-testid="play-store-button-soon">
        <PlayLogo />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wide opacity-70">Google Play</span>
          <span className="block text-sm font-bold">Bientôt disponible</span>
        </span>
      </span>
    )}
  </div>
);

export const QRBadge = ({ value, className = "", dark = false }) => (
  <div
    className={`inline-flex items-center gap-3.5 rounded-2xl border p-3.5 ${
      dark ? "border-paper/20 bg-white/10 backdrop-blur" : "border-ink/10 bg-white shadow-sm"
    } ${className}`}
    data-testid="qr-badge"
  >
    <QRCodeSVG value={value} size={92} bgColor="#FFFFFF" fgColor="#0F172A" marginSize={1} />
    <div className={`text-xs leading-snug ${dark ? "text-paper" : "text-ink"}`}>
      <p className="font-bold">Scanne pour ouvrir</p>
      <p className={`mt-0.5 break-all ${dark ? "text-paper/70" : "text-ink/50"}`}>{value}</p>
    </div>
  </div>
);

export default StoreButtons;